import { render, staticRenderFns } from "./ExternalFTPForm.vue?vue&type=template&id=0fae108a&"
import script from "./ExternalFTPForm.vue?vue&type=script&lang=js&"
export * from "./ExternalFTPForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports